import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const JoinForm = () => {
    const [meetingId, setMeetingId] = useState('');
    const navigate = useNavigate();

    const handleJoinMeeting = (e) => {
        e.preventDefault();
        if (meetingId.trim()) {
            navigate(`/${meetingId.trim()}`);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <div className="max-w-md mx-auto px-4 py-8">
                <div className="text-center mb-8">
                    <h1 className="text-4xl font-bold text-gray-900 mb-2">OWHS Meet</h1>
                </div>

                <div className="bg-white rounded-lg shadow-md p-6">
                    <form onSubmit={handleJoinMeeting} className="space-y-4">
                        <div>
                            <label htmlFor="userName" className="block text-xl font-medium text-gray-700 mb-2">
                                Wat is de naam van de meeting?
                            </label>
                            <input
                                type="text"
                                id="meetingId"
                                value={meetingId}
                                onChange={(e) => setMeetingId(e.target.value)}
                                placeholder="Meetingnaam"
                                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={!meetingId.trim()}
                            className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                        >
                            Deelnemen
                        </button>
                    </form>

                    <div className="mt-6 text-center">
                        <p className="text-sm text-gray-500">
                            Of gebruik een directe meeting link die door de organisator is verstrekt
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JoinForm;